var BASWebServices;
(function (BASWebServices) {
    var WebServiceResonseLink = (function () {
        function WebServiceResonseLink(xmlString) {
            xmlString = xmlString.replace(/\<div.+\'\>/g, '');
            xmlString = xmlString.replace(/\<\/div.*\>/g, '');
            var xmlParsed = $.parseXML(xmlString);
            var nl = xmlParsed.firstChild.childNodes;
            this.builder(nl);
        }
        WebServiceResonseLink.prototype.builder = function (xmlStringParsed) {
            for (var i = 0; i < xmlStringParsed.length; i++) {
                var currentNode = xmlStringParsed[i];
                var currentNodeName = currentNode.nodeName;
                switch (currentNodeName) {
                    case 'success':
                        var currentVal = currentNode.textContent;
                        if (currentVal == "true")
                            this.success = true;
                        else
                            this.success = false;
                        break;
                    case 'downloadLink':
                        this.downloadLink = currentNode.textContent;
                        break;
                    case 'output':
                        this.output = currentNode.textContent;
                        break;
                    case 'warnings':
                        this.warnings = currentNode.textContent;
                        break;
                    default:
                        console.error("This should not had happened. In WebServiceResponsLink there is no value " + currentNodeName + " this is an error");
                }
            }
        };
        WebServiceResonseLink.prototype.toString = function () {
            var resString = "";
            resString += "Val: " + this.success + " | ";
            resString += "downloadLink: " + this.downloadLink + " | ";
            resString += "output: " + this.output + " | ";
            resString += "warnings: " + this.warnings + " \n";
            return resString;
        };
        return WebServiceResonseLink;
    }());
    BASWebServices.WebServiceResonseLink = WebServiceResonseLink;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=WebServiceResponseLink.js.map